<svg-icon [src]="iconSrc" [svgClass]="className" [svgStyle]="defaultStyle" [applyClass]="true"></svg-icon>
